  function initVpcTrend(sectionEl) {
    if (!sectionEl) return;
    if (sectionEl.dataset.vpcTrendInit === 'true') return;

    const closeAllVariantOverlays = () => {
      sectionEl.querySelectorAll('[data-vpc-variant-overlay]').forEach((overlay) => {
        overlay.hidden = true;
      });
      sectionEl.querySelectorAll('[data-vpc-variant-toggle]').forEach((b) => {
        b.setAttribute('aria-expanded', 'false');
      });

      // Reanudar video del slide activo si aplica
      sectionEl.querySelectorAll('.swiper-slide-active video').forEach((v) => {
        vpcPlayVideoWithAudioSync(sectionEl, v);
      });
    };

    // Asegurar label default en botones ATC (1 vez por instancia presente)
    sectionEl.querySelectorAll('[data-vpc-atc-form]').forEach((form) => {
      const atcBtn = form.querySelector('[data-vpc-atc-btn]');
      if (atcBtn && !atcBtn.dataset.defaultLabel) {
        atcBtn.dataset.defaultLabel = atcBtn.textContent.trim();
      }

      if (!form.dataset.vpcAtcBound) {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          const btn = form.querySelector('[data-vpc-atc-btn]');
          const formData = new FormData(form);
          addToCartAJAX(formData, { button: btn, closeDrawerOnSuccess: false, closeAccordionsOnSuccess: false });
        });
        form.dataset.vpcAtcBound = 'true';
      }
    });

    // Estado inicial: todo cerrado (importante al cargar/recargar)
    closeAllVariantOverlays();

    // Delegación de eventos: funciona también en slides clonados (loop)
    sectionEl.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-vpc-variant-toggle]');
      const addBtn = e.target.closest('[data-vpc-variant-add]');
      const row = e.target.closest('[data-vpc-variant-row]');
      const insideOverlay = e.target.closest('[data-vpc-variant-overlay]');
      const insideSheet = e.target.closest('[data-vpc-variant-sheet]');

      // Click en backdrop (overlay pero fuera del sheet) cierra
      if (insideOverlay && !insideSheet) {
        closeAllVariantOverlays();
        return;
      }

      // Toggle abre/cierra overlay de su card
      if (toggle) {
        e.preventDefault();
        const card = toggle.closest('.vpc-trend-card');
        const overlay = card?.querySelector('[data-vpc-variant-overlay]');
        if (!overlay) return;

        const willOpen = overlay.hidden;
        closeAllVariantOverlays();
        overlay.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

        const slide = card?.closest('.swiper-slide');
        const video = card?.querySelector('video');
        if (slide?.classList.contains('swiper-slide-active') && video) {
          if (willOpen) {
            try { video.pause(); } catch (_) {}
          } else {
            vpcPlayVideoWithAudioSync(sectionEl, video);
          }
        }
        return;
      }

      // Botón + agrega al carrito
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (addBtn.disabled) return;

        const variantId = addBtn.dataset.variantId;
        if (!variantId) return;

        if (!addBtn.dataset.defaultLabel) addBtn.dataset.defaultLabel = addBtn.textContent.trim() || '+';

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        addToCartAJAX(formData, { button: addBtn, closeDrawerOnSuccess: false, closeAccordionsOnSuccess: false });
        return;
      }

      // Click en fila selecciona variante (si hay stock) y cierra
      if (row) {
        const available = row.dataset.variantAvailable === 'true';
        if (!available) return;

        const variantId = row.dataset.variantId;
        const priceCents = row.dataset.variantPrice;
        const card = row.closest('.vpc-trend-card');
        const form = card?.querySelector('[data-vpc-atc-form]');
        const idInput = form?.querySelector('[data-vpc-variant-id]');
        const priceEl = card?.querySelector('[data-vpc-price]');

        if (variantId && idInput) idInput.value = variantId;
        if (priceEl && priceCents) {
          const cents = Number(priceCents);
          if (!Number.isNaN(cents)) {
            const money = (cents / 100).toLocaleString(undefined, {
              style: 'currency',
              currency: Shopify?.currency?.active || undefined
            });
            priceEl.textContent = money;
          }
        }

        if (row.hasAttribute('data-vpc-product-list-row')) {
          const titleEl = card?.querySelector('[data-vpc-pl-title]');
          const thumbEl = card?.querySelector('[data-vpc-pl-thumb]');
          if (titleEl && row.dataset.productTitle) {
            titleEl.textContent = row.dataset.productTitle;
          }
          if (thumbEl && row.dataset.productImage) {
            thumbEl.src = row.dataset.productImage;
          }
          if (form && row.dataset.productHandle) {
            form.dataset.productHandle = row.dataset.productHandle;
          }
        }

        closeAllVariantOverlays();
        return;
      }

      // Click dentro del sheet no debe cerrar por afuera
      if (insideSheet) return;
    });

    sectionEl.addEventListener('keydown', (e) => {
      const row = e.target.closest('[data-vpc-variant-row]');
      if (!row) return;
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      row.click();
    });

    document.addEventListener('click', (e) => {
      if (!sectionEl.contains(e.target)) return;
      const insideToggle = e.target.closest('[data-vpc-variant-toggle]');
      const insideOverlay = e.target.closest('[data-vpc-variant-overlay]');
      const insideSheet = e.target.closest('[data-vpc-variant-sheet]');

      // Click en backdrop (overlay pero fuera del sheet) cierra
      if (insideOverlay && !insideSheet) {
        closeAllVariantOverlays();
        return;
      }

      // Click fuera del overlay y fuera del toggle cierra
      if (!insideOverlay && !insideToggle) closeAllVariantOverlays();
    });

    sectionEl.dataset.vpcTrendInit = 'true';
  }

  function vpcAudioMuted(sectionEl) {
    return sectionEl.dataset.vpcAudioMuted !== 'false';
  }

  function applyVpcAudioToVideos(sectionEl) {
    const muted = vpcAudioMuted(sectionEl);
    sectionEl.querySelectorAll('.video-card video').forEach((v) => {
      v.muted = muted;
    });
  }

  function syncVpcVideoControlVisibility(card, btn, isActive) {
    if (!btn) return;
    if (isActive) {
      btn.removeAttribute('aria-hidden');
      btn.removeAttribute('tabindex');
    } else {
      btn.setAttribute('aria-hidden', 'true');
      btn.setAttribute('tabindex', '-1');
    }
  }

  function syncVpcMuteButtons(sectionEl) {
    const muted = vpcAudioMuted(sectionEl);
    sectionEl.querySelectorAll('.video-card').forEach((card) => {
      const isActive = card.classList.contains('swiper-slide-active');
      const muteBtn = card.querySelector('[data-vpc-mute-toggle]');
      syncVpcVideoControlVisibility(card, muteBtn, isActive);
      if (muteBtn) {
        const icM = muteBtn.querySelector('.vpc-mute-btn__icon--muted');
        const icU = muteBtn.querySelector('.vpc-mute-btn__icon--unmuted');
        if (icM) icM.hidden = !muted;
        if (icU) icU.hidden = muted;
        muteBtn.setAttribute('aria-pressed', muted ? 'false' : 'true');
        muteBtn.setAttribute('aria-label', muted ? 'Activar audio del video' : 'Silenciar video');
      }
      const basketBtn = card.querySelector('.vpc-basket-btn');
      syncVpcVideoControlVisibility(card, basketBtn, isActive);
    });
  }

  function initVpcMuteControls(sectionEl) {
    if (!sectionEl || sectionEl.dataset.vpcMuteBound === 'true') return;
    sectionEl.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-vpc-mute-toggle]');
      if (!btn || !sectionEl.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      const muted = vpcAudioMuted(sectionEl);
      sectionEl.dataset.vpcAudioMuted = muted ? 'false' : 'true';
      applyVpcAudioToVideos(sectionEl);
      syncVpcMuteButtons(sectionEl);
    });
    sectionEl.dataset.vpcMuteBound = 'true';
  }

  function vpcPlayVideoWithAudioSync(sectionEl, video) {
    applyVpcAudioToVideos(sectionEl);
    syncVpcMuteButtons(sectionEl);
    if (!video) return;
    if (window.theme && typeof theme.playInlineVideo === 'function') {
      theme.playInlineVideo(video, { allowSound: true });
      return;
    }
    const p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  // Función única de inicialización (por sección)
  function initVideoProductCarousel() {
    document.querySelectorAll('[data-vpc-section]').forEach((sectionEl) => {
      const sliderContainer = sectionEl.querySelector('[data-vpc-swiper]');
      if (!sliderContainer || sliderContainer.classList.contains('swiper-initialized')) return;

      initVpcTrend(sectionEl);
      initVpcMuteControls(sectionEl);
      applyVpcAudioToVideos(sectionEl);

      const mobileSlidesRaw = parseFloat(sectionEl.dataset.vpcMobileSlides);
      let mobileSlides = Number.isFinite(mobileSlidesRaw) ? mobileSlidesRaw : 1.3;
      mobileSlides = Math.min(4, Math.max(1, mobileSlides));

      const mobileSpaceRaw = parseInt(sectionEl.dataset.vpcMobileSpace, 10);
      let mobileSpace = Number.isFinite(mobileSpaceRaw) ? mobileSpaceRaw : 30;
      mobileSpace = Math.min(48, Math.max(0, mobileSpace));

      const swiper = new Swiper(sliderContainer, {
        slidesPerView: mobileSlides,
        centeredSlides: true,
        loop: true,
        spaceBetween: mobileSpace,
        grabCursor: true,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        watchOverflow: false,
        navigation: {
          nextEl: sectionEl.querySelector('[data-vpc-next]'),
          prevEl: sectionEl.querySelector('[data-vpc-prev]')
        },
        breakpoints: {
          768: { slidesPerView: 3, spaceBetween: 40 },
          1024: { slidesPerView: 5, spaceBetween: 10 }
        },
        on: {
          init: function() {
            const activeVideo = this.slides[this.activeIndex]?.querySelector('video');
            vpcPlayVideoWithAudioSync(sectionEl, activeVideo);
          },
          slideChange: function() {
            // Pausar videos solo dentro de esta sección
            sectionEl.querySelectorAll('.video-card video').forEach(v => v.pause());
            const activeSlide = this.slides[this.activeIndex];
            const video = activeSlide?.querySelector('video');
            vpcPlayVideoWithAudioSync(sectionEl, video);
            syncVpcMuteButtons(sectionEl);

            // Cerrar acordeones abiertos solo dentro de esta sección
            sectionEl.querySelectorAll('.video-card').forEach(card => card.classList.remove('is-open'));
          }
        }
      });

      // Recalcular Swiper cuando el video define la altura real del slide
      const updateSwiperOnVideoMeta = function() {
        swiper.update();
      };
      sectionEl.querySelectorAll('.video-card video').forEach((video) => {
        if (video.readyState >= 1) {
          updateSwiperOnVideoMeta();
        } else {
          video.addEventListener('loadedmetadata', updateSwiperOnVideoMeta, { once: true });
        }
      });
    });
  }

  // Ejecución inicial al cargar la página
  document.addEventListener('DOMContentLoaded', initVideoProductCarousel);

  // EVENTOS DEL EDITOR DE SHOPIFY (Crucial para que se vea bien desde el momento 1)
  if (window.Shopify && window.Shopify.designMode) {
    // Se ejecuta cada vez que agregas la sección o cambias un ajuste
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.videoSwiper')) {
        initVideoProductCarousel();
      }
    });

    // Se ejecuta al mover de posición la sección o interactuar con ella
    document.addEventListener('shopify:section:select', (event) => {
       initVideoProductCarousel();
    });
  }







  // 2. Función para Abrir/Cerrar el acordeón (Tapa el video)
  function toggleCard(element) {
    if (!element || element.hasAttribute('data-vpc-no-toggle') || element.classList.contains('accordion-header--no-toggle')) {
      return;
    }
    const card = element.closest('.video-card');
    if (!card) return;
    if (!card.classList.contains('is-open')) {
      document.querySelectorAll('.video-card').forEach(c => c.classList.remove('is-open'));
    }
    card.classList.toggle('is-open');
  }

  function handleize(str) {
    return String(str || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-+/g, '-');
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getColorOptionIndex(product) {
    const colorNames = ['color', 'colour', 'tono', 'couleur', 'farbe', 'kleur', 'farge'];
    const options = product.options || [];
    const idx = options.findIndex((opt) => colorNames.indexOf(String(opt).toLowerCase()) !== -1);
    return idx >= 0 ? idx : 0;
  }

  function getVariantColorValue(variant, colorIndex) {
    const key = 'option' + (colorIndex + 1);
    return variant[key] || variant.title || '';
  }

  function findImageSlideIndex(product, variant) {
    if (!variant || !variant.featured_image || !variant.featured_image.src) return -1;
    const src = variant.featured_image.src;
    const images = product.images || [];
    for (let i = 0; i < images.length; i++) {
      const img = images[i];
      if (img === src || (typeof img === 'string' && (src.indexOf(img) !== -1 || img.indexOf(src.split('?')[0]) !== -1))) {
        return i;
      }
      // Match by filename without size suffix (Shopify CDN)
      const base = src.replace(/_\d+x\d*|\.\w+(\?.*)?$/g, '');
      if (typeof img === 'string' && img.indexOf(base.split('/').pop().split('.')[0]) !== -1) {
        return i;
      }
    }
    // featured_image.position is 1-based in Ajax API
    if (variant.featured_image.position) {
      return Math.max(0, variant.featured_image.position - 1);
    }
    return -1;
  }

  // 3. Lógica del Drawer Lateral (Quick View)
  async function openDrawer(handle) {
    const drawer = document.getElementById('product-drawer');
    const overlay = document.querySelector('.drawer-overlay');
    const content = document.getElementById('drawer-content');

    content.innerHTML = '<p style="padding:20px;">Cargando producto...</p>';
    drawer.classList.add('active');
    overlay.classList.add('active');

    try {
      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();
      const formattedPrice = (product.price / 100).toLocaleString(undefined, {style: 'currency', currency: Shopify.currency.active });

      const colorIndex = getColorOptionIndex(product);
      const firstAvailable = product.variants.find((v) => v.available) || product.variants[0];
      const initialColorValue = firstAvailable ? getVariantColorValue(firstAvailable, colorIndex) : '';
      const productOptions = product.options || [];
      const hasOnlyDefaultVariant =
        product.variants.length === 1 &&
        (product.variants[0].title === 'Default Title' ||
          (productOptions.length === 1 && String(productOptions[0]).toLowerCase() === 'title'));

      const swatchesHtml = product.variants
        .map((v) => {
          const colorValue = getVariantColorValue(v, colorIndex);
          const swtClass = 'swt' + handleize(colorValue);
          const isSelected = firstAvailable && Number(v.id) === Number(firstAvailable.id);
          const soldoutClass = v.available ? '' : ' soldout';
          const selectedClass = isSelected ? ' is-selected' : '';
          const checked = isSelected ? ' checked' : '';
          const disabledAttr = v.available ? '' : ' disabled';
          const safeLabel = escapeHtml(colorValue);
          const inputId = 'drawer-swatch-' + v.id;

          return (
            '<div class="swatch-element drawer-swatch-element' + soldoutClass + selectedClass + '" data-variant-id="' + v.id + '">' +
              '<input class="swatchInput drawer-swatch-input" type="radio" name="drawer-swatch" id="' + inputId + '" value="' + v.id + '"' + checked + disabledAttr + ' data-color-label="' + safeLabel + '" />' +
              '<label class="swatchLbl color ' + swtClass + '" for="' + inputId + '"></label>' +
              '<span class="tooltip-label top">' + safeLabel + '</span>' +
            '</div>'
          );
        })
        .join('');

      const descriptionText = (product.description || '').replace(/<[^>]*>/g, '').trim();
      const shortDescription = descriptionText.length > 95
        ? descriptionText.substring(0, 95) + '...'
        : descriptionText;

      content.innerHTML = `
        <div class="drawer-header">
          <h4>Elige tu tono</h4>
          <button type="button" class="drawer-close" onclick="closeDrawer()" aria-label="Cerrar">&times;</button>
        </div>
        <form id="ajax-add-form" class="drawer-form" method="post">
          <div class="drawer-scroll">
            <div class="swiper drawerSwiper">
              <div class="swiper-wrapper">
                ${product.images.map(img => `<div class="swiper-slide"><img src="${img}" alt=""></div>`).join('')}
              </div>
              <div class="swiper-pagination"></div>
            </div>
            <div class="drawer-info">
              <h2>${product.title}</h2>
              <div class="drawer-rating">★★★★★ <span class="drawer-rating-count">(15)</span></div>
              <div class="product-description">${shortDescription}</div>
              <a href="${product.url}" class="drawer-details-link">Ver detalles del producto</a>
              <div class="drawer-color-swatches">
                ${hasOnlyDefaultVariant ? '' : `
                <div class="drawer-swatch-header">
                  Tono: <span class="drawer-swatch-label">${escapeHtml(initialColorValue)}</span>
                </div>
                <div class="drawer-swatch-list">
                  ${swatchesHtml}
                </div>
                `}
                <input type="hidden" name="id" id="drawer-variant-id" value="${firstAvailable ? firstAvailable.id : ''}" />
              </div>
            </div>
          </div>
          <div class="drawer-cta">
            <div class="drawer-price" id="drawer-price">${formattedPrice}</div>
            <button type="submit" id="add-to-cart-btn" class="btn btn1 w_100" data-default-label="Agregar al carrito">
              Agregar al carrito
            </button>
          </div>
        </form>
      `;

      const drawerSwiper = new Swiper('.drawerSwiper', {
        pagination: { el: '.swiper-pagination', clickable: true },
        nested: true
      });

      const variantInput = document.getElementById('drawer-variant-id');
      const priceEl = document.getElementById('drawer-price');
      const swatchLabel = content.querySelector('.drawer-swatch-label');
      const swatchList = content.querySelector('.drawer-swatch-list');

      const updateBtnPrice = (variantId) => {
        if (!priceEl) return;
        const v = product.variants.find((x) => Number(x.id) === Number(variantId));
        const price = (v && typeof v.price === 'number' ? v.price : product.price) / 100;
        const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : undefined;
        priceEl.textContent = price.toLocaleString(undefined, { style: 'currency', currency });
      };

      const selectVariant = (variantId) => {
        const v = product.variants.find((x) => Number(x.id) === Number(variantId));
        if (!v || !v.available) return;

        if (variantInput) variantInput.value = String(v.id);

        if (swatchList) {
          swatchList.querySelectorAll('.drawer-swatch-element').forEach((el) => {
            const match = Number(el.getAttribute('data-variant-id')) === Number(v.id);
            el.classList.toggle('is-selected', match);
            const radio = el.querySelector('.drawer-swatch-input');
            if (radio) radio.checked = match;
          });
        }

        if (swatchLabel) {
          swatchLabel.textContent = getVariantColorValue(v, colorIndex);
        }

        updateBtnPrice(v.id);

        const slideIndex = findImageSlideIndex(product, v);
        if (drawerSwiper && slideIndex >= 0 && typeof drawerSwiper.slideTo === 'function') {
          drawerSwiper.slideTo(slideIndex);
        }
      };

      if (swatchList) {
        swatchList.addEventListener('click', (e) => {
          const el = e.target.closest('.drawer-swatch-element');
          if (!el || el.classList.contains('soldout')) return;
          e.preventDefault();
          selectVariant(el.getAttribute('data-variant-id'));
        });
      }

      if (firstAvailable) {
        updateBtnPrice(firstAvailable.id);
      }

      // Evento AJAX para el formulario
      document.getElementById('ajax-add-form').addEventListener('submit', function(e) {
        e.preventDefault();
        const formData = new FormData(this);
        addToCartAJAX(formData);
      });

    } catch (error) {
      content.innerHTML = '<p style="padding:20px;">Error al cargar el producto.</p>';
    }
  }

  function addToCartAJAX(formData, opts) {
    const options = opts || {};
    const btn = options.button || document.getElementById('add-to-cart-btn');
    const cartDrawer = document.querySelector('cart-drawer');
    const closeDrawerOnSuccess = options.closeDrawerOnSuccess !== false;
    const closeAccordionsOnSuccess = options.closeAccordionsOnSuccess !== false;

    if (btn) {
      btn.disabled = true;
      btn.style.opacity = '0.55';
    }

    // 1. Preparamos los datos para que Shopify devuelva las secciones necesarias
    // Tu tema necesita saber qué secciones renderizar para actualizar el drawer
    if (cartDrawer) {
      formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    }

    // 2. Petición AJAX
    fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      }
    })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        // Manejo de error (ej. sin inventario)
        alert(response.description);
        return;
      }

      // A. Cerramos tus elementos visuales (Detalles del producto)
      if (closeDrawerOnSuccess) closeDrawer();
      if (closeAccordionsOnSuccess) document.querySelectorAll('.video-card').forEach(c => c.classList.remove('is-open'));

      // B. USAMOS LA FUNCIÓN NATIVA DE TU TEMA
      // Esto actualiza el HTML del carrito y lo abre automáticamente
      if (cartDrawer) {
        cartDrawer.renderContents(response);
      } else {
        // Fallback si por alguna razón el drawer no existe
        window.location.href = window.routes.cart_url;
      }
    })
    .catch((e) => {
      console.error('Error al añadir:', e);
    })
    .finally(() => {
      if (btn) {
        btn.disabled = false;
        btn.style.opacity = '';
      }
    });
  }

  function closeDrawer() {
    document.getElementById('product-drawer').classList.remove('active');
    document.querySelector('.drawer-overlay').classList.remove('active');
  }